/**
 * Centralized column width/label config, mirroring the pattern in
 * src/screens/recipe_simulator/newList/components/recipeListTable.columns.ts
 * — a single source of truth for the table's fixed layout instead of widths
 * scattered across each `<TableHead>`/`<TableCell>`.
 */
export const ingredientTableColumnClass = {
  name: "tw-w-[28%] tw-min-w-[10rem]",
  supplier: "tw-w-[20%] tw-min-w-[8rem]",
  unitSize: "tw-w-[12%] tw-min-w-[6rem] tw-whitespace-nowrap",
  climateImpact: "tw-w-[20%] tw-min-w-[9rem]",
  dataType: "tw-w-[12%] tw-min-w-[7rem]",
  actions: "tw-w-[8%] tw-min-w-[6rem]"
} as const;

type IngredientColumnKey = Exclude<keyof typeof ingredientTableColumnClass, "actions">;

export const INGREDIENT_TABLE_COLUMNS: ReadonlyArray<{ key: IngredientColumnKey; label: string }> = [
  { key: "name", label: "Ingredient Name" },
  { key: "supplier", label: "Supplier Name" },
  { key: "unitSize", label: "Unit Size" },
  { key: "climateImpact", label: "Climate Change Impact (kgCO2eq/kg)" },
  { key: "dataType", label: "Data Type" }
];
